import Modal from '@sdk/components/ui/modal/Modal';
import { ModalState } from '@sdk/components/ui/modal/useModalState';

import { ShiftFeedbackNotificationModal } from '@web/timesheets/ShiftFeedback/ShiftFeedbackNotificationModal';
import BodyPortal from '@web/components/BodyPortal';
import { DashboardNotification } from '@web/dashboard/types/DashboardNotification';
import { AnnouncementNotificationModal } from '@web/announcements/AnnouncementNotification/AnnouncementNotificationModal';
import { TimesheetNotificationModal } from '@web/timesheets/TimesheetsNotification/TimesheetNotificationModal';
import { isAnnouncementDashboardNotification } from '@web/dashboard/utils/isAnnouncementDashboardNotification';
import { isTimesheetsDashboardNotification } from '@web/dashboard/utils/isTimesheetsDashboardNotification';
import { isShiftTasksDashboardNotification } from '@web/dashboard/utils/isShiftTasksDashboardNotification';
import { ShiftTaskNotificationModal } from '@web/shiftTasks/ShiftTaskNotificationModal/ShiftTaskNotificationModal';
import { isShiftFeedbackDashboardNotification } from '@web/dashboard/utils/isShiftFeedbackDashboardNotification';

type Props = {
  modalState: ModalState;
  notification: DashboardNotification;
  onClose: () => void;
};

export const NotificationModal = ({ modalState, notification, onClose }: Props) => {
  const { isVisible, close, config } = modalState;

  if (!notification) {
    return null;
  }

  if (isAnnouncementDashboardNotification(notification)) {
    return (
      <BodyPortal>
        <Modal isVisible={isVisible} onDismiss={close} config={config} fixed>
          <AnnouncementNotificationModal notification={notification} onClose={onClose} />
        </Modal>
      </BodyPortal>
    );
  }

  if (isShiftTasksDashboardNotification(notification)) {
    return (
      <BodyPortal>
        <Modal isVisible={isVisible} onDismiss={close} config={config} fixed>
          <ShiftTaskNotificationModal onClose={close} notification={notification} />
        </Modal>
      </BodyPortal>
    );
  }

  if (isShiftFeedbackDashboardNotification(notification)) {
    return (
      <ShiftFeedbackNotificationModal
        notification={notification}
        isVisible={isVisible}
        close={close}
      />
    );
  }

  if (isTimesheetsDashboardNotification(notification)) {
    return (
      <TimesheetNotificationModal notification={notification} isVisible={isVisible} close={close} />
    );
  }

  return null;
};
